var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3346 13.333L15.0013 13.333C15.4433 13.333 15.8673 13.1574 16.1798 12.8449C16.4924 12.5323 16.668 12.1084 16.668 11.6663L16.668 4.99967C16.668 4.55765 16.4924 4.13372 16.1798 3.82116C15.8673 3.5086 15.4433 3.33301 15.0013 3.33301L8.33464 3.33301C7.89261 3.33301 7.46869 3.5086 7.15612 3.82116C6.84356 4.13372 6.66797 4.55765 6.66797 4.99967L6.66797 6.66634M11.668 6.66634C12.11 6.66634 12.5339 6.84194 12.8465 7.1545C13.159 7.46706 13.3346 7.89098 13.3346 8.33301L13.3346 14.9997C13.3346 15.4417 13.159 15.8656 12.8465 16.1782C12.5339 16.4907 12.11 16.6663 11.668 16.6663L5.0013 16.6663C4.55927 16.6663 4.13535 16.4907 3.82279 16.1782C3.51023 15.8656 3.33464 15.4417 3.33464 14.9997L3.33464 8.33301C3.33464 7.89098 3.51023 7.46706 3.82279 7.1545C4.13535 6.84194 4.55927 6.66634 5.0013 6.66634L11.668 6.66634Z",
    stroke: "#00FFE0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.6ced9b66304f3aac96d3dc50468df197.svg";
export { ForwardRef as ReactComponent };